<template>
	<div>
		<list-page-gen :options="options" />
	</div>
</template>

<script>
import ListPageGen from './ListPageGen.vue'

const config = {
	options: {
		resource: 'user-tag-keys',
		display: [{ key: 'id' }],
		syncEnabled: false,
		canEdit: false
	}
}

export default {
	name: 'UserTagKeysList',
	components: { ListPageGen },
	data: () => config
}
</script>
